import React from "react";
import StarRatings from "react-star-ratings";
import { GlobalStore } from "../../stores/global";
import { useApi } from "../../hooks/useApi";
import { AppleIco, CHPlayIco, LocationIco } from "@speedoc/design-assets/build/icons";

export default function LocationAndRating({ content }) {
  const { currentCountryCode: countryCode } = GlobalStore.useState(s => s);
  const rating = useApi({ url: `https://itunes.apple.com/lookup?id=1288838601&country=${countryCode}`, type: "post" });
  const stars = rating?.results?.[0]?.averageUserRating ?? 5.0;

  return (
    <div id="locationAndRating">
      <div className="location">
        <LocationIco />
        <div>{content.bottomText}</div>
      </div>
      <div className="rating">
        <div className="rate">{Math.round(stars * 10) / 10}</div>
        <StarRatings
          rating={Math.round(stars * 10) / 10}
          starRatedColor="#BBBBBB"
          starEmptyColor="#FFFFFF"
          numberOfStars={5}
          name="rating"
          starDimension="18px"
          starSpacing="2px"
        />
        <div className="stores">
          <a className="apple" target="tab" href="https://apps.apple.com/sg/app/speedoc/id1288838601?mt=8">
            <AppleIco />
          </a>
          <a
            className="chPlay"
            target="tab"
            href="https://play.google.com/store/apps/details?id=com.speedoc.patient&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
            <CHPlayIco />
          </a>
        </div>
      </div>
    </div>
  );
}
